"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from "react";
interface CurrencyInputProps {
  label?: string;
  placeholder?: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
}
export const CurrencyInput = t0 => {
  const $ = _c(13);
  const {
    label,
    value,
    onChange,
    placeholder
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = label && <label className="text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">{label}</label>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = typeof value === "undefined" ? "" : value.toString();
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onChange) {
    t3 = e => {
      const numValue = parseFloat(e.target.value);
      onChange(isNaN(numValue) ? undefined : numValue);
    };
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== placeholder || $[7] !== t2 || $[8] !== t3) {
    t4 = <input type="number" placeholder={placeholder} value={t2} onChange={t3} className="w-full p-2 text-xs bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md focus:border-brand-500 focus:ring-1 focus:ring-brand-500 outline-none dark:text-white placeholder-slate-400 focus:z-10" />;
    $[6] = placeholder;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="flex flex-col relative">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};